import { render, staticRenderFns } from "./UguReward.vue?vue&type=template&id=04ec9017&"
import script from "./UguReward.vue?vue&type=script&lang=js&"
export * from "./UguReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports